export enum StructureNodeTypes {
    Container = 1 || "container",
    Point = 2 || "point",
    Person = 3 || "person"
}